import { render, staticRenderFns } from "./CreateAdminForm.vue?vue&type=template&id=275883a4&scoped=true&"
import script from "./CreateAdminForm.vue?vue&type=script&lang=js&"
export * from "./CreateAdminForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275883a4",
  null
  
)

export default component.exports